import {
    Button,
    ButtonProps,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Popover,
    SvgIconTypeMap,
    Typography,
    useTheme,
} from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import BusySpinner from './BusySpinner'

import React, { useState } from 'react'
import { IsEmpty, IsNotEmpty } from '../Helpers';

export interface ButtonExProps extends Omit<ButtonProps, 'onClick'> {
    onClick?: (event?: React.MouseEvent<HTMLButtonElement>) => (void | Promise<void>);
    headerContent?: string | React.ReactNode;
    hoverContent?: string | React.ReactNode;
    message?: string | React.ReactNode;
    icon?: OverridableComponent<SvgIconTypeMap<{}, "svg">>;
}

const ButtonEx = ({ headerContent = 'Are you sure?', hoverContent, message, onClick, ...props }: ButtonExProps) => {
    const theme = useTheme();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [busy, setBusy] = useState<boolean>(false);
    const [open, setOpen] = useState<boolean>(false);

    const handleClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
        if (IsEmpty(message))//if the message is empty, there is no point in displaying the confirmation.  just run it.
            await onClick(event);
        else
            setOpen(true);
    };

    const handleConfirm = async (event: React.MouseEvent<HTMLButtonElement>) => {
        try {
            setBusy(true);
            await onClick(event);
            setOpen(false);
        } catch (error) {

        } finally {
            setBusy(false);
        }
    };
    const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };
    const popoverOpen = IsNotEmpty(hoverContent) && Boolean(anchorEl);

    return <>
        <Button {...props}
            onClick={handleClick}
            aria-owns={popoverOpen ? 'mouse-over-popover' : undefined}
            aria-haspopup={IsNotEmpty(hoverContent)}
            onMouseEnter={handlePopoverOpen}
            onMouseLeave={handlePopoverClose} />
        <Dialog aria-labelledby="customized-dialog-title" open={open} fullWidth={true} color="red">
            <BusySpinner busy={busy}>
                <DialogTitle id="customized-dialog-title">
                    {headerContent}
                </DialogTitle>
                <DialogContent dividers sx={{ padding: theme.spacing(2) }}>
                    <DialogContentText id="alert-dialog-slide-description">
                        {message}
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ margin: 0, padding: theme.spacing(1) }}>
                    <Button onClick={() => setOpen(false)} variant='text' color="inherit">Cancel</Button>
                    <Button onClick={handleConfirm} variant='outlined' color='primary'>Ok</Button>
                </DialogActions>
            </BusySpinner>

        </Dialog>
        <Popover
            id="mouse-over-popover"
            sx={{ pointerEvents: 'none'}}
            open={popoverOpen}
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            onClose={handlePopoverClose}
            disableRestoreFocus>
            <Typography sx={{padding: theme.spacing(.5), backgroundColor: theme.palette.background.neutral }}>{hoverContent}</Typography>
        </Popover>
    </>;
}

export default ButtonEx;

